export default __webpack_public_path__ + "static/media/misc-books5-1024w.cc8d9c8b.avif";